import type {
    FC
} from "react";
import {
    type GestureResponderEvent,
    Text as NativeText,
    type MouseEvent,
    Platform
} from "react-native";
import type ILinkProps from "./type";
import {
    useStyles
} from "./stylesheet";
import {
    useInteractionState
} from "../../../../helpers/interaction";
import {
    MARKDOWN_LINK_HREF_ATTRS
} from "../../constant";
import {
    handleMarkdownLinkPress
} from "../../util";
import stylesheet from "../../stylesheet";

const MarkdownLink: FC<ILinkProps> = ({
    onLinkPress,
    children,
    radiuses,
    borders,
    colors,
    style,
    url
}) => {
    const {
        interactionHandlers,
        isFocusVisible,
        isHovered,
        isPressed
    } = useInteractionState();

    const {
        link: linkDynamicStyle
    } = useStyles({
        isFocusVisible,
        isHovered,
        isPressed,
        radiuses,
        borders,
        colors
    });

    const isWeb = Platform.OS === "web";

    const onMouseLeave = (event: GestureResponderEvent & MouseEvent) => {
        interactionHandlers.onHoverOut(event);

        interactionHandlers.onPressOut(event);
    };

    const onPress = (event: GestureResponderEvent) => {
        handleMarkdownLinkPress({
            onLinkPress,
            event,
            url
        });
    };

    const webLinkProps = isWeb ? {
        onMouseEnter: interactionHandlers.onHoverIn,
        onMouseDown: interactionHandlers.onPressIn,
        onMouseUp: interactionHandlers.onPressOut,
        dataSet: interactionHandlers.dataSet,
        onFocus: interactionHandlers.onFocus,
        hrefAttrs: MARKDOWN_LINK_HREF_ATTRS,
        onBlur: interactionHandlers.onBlur,
        onMouseLeave,
        href: url
    } : {};

    return <NativeText
        {...webLinkProps}
        onPressOut={isWeb ? undefined : interactionHandlers.onPressOut}
        onPressIn={isWeb ? undefined : interactionHandlers.onPressIn}
        onPress={isWeb && !onLinkPress ? undefined : onPress}
        suppressHighlighting={true}
        style={[
            style,
            stylesheet.link,
            linkDynamicStyle
        ]}
        role="link"
    >
        {children}
    </NativeText>;
};
export default MarkdownLink;
